import ClickableTile from '@/SearchResults/ClickableTile';
import { SELL_MY_CAR_URL } from '~/constants';
import { useIsMobile } from '~/contexts/DeviceContext';
import CarIcon from '~/icons/CarIcon';
import BlueButton from '~/styles/Button/BlueButton';
import StyledTile from '../components/StyledTile.style';
import TextLines from '../components/TextLines';

export default function TradeYourCarTile() {
  const isMobile = useIsMobile();

  return (
    <ClickableTile
      link={SELL_MY_CAR_URL}
      tileId="tradetile"
      name="TradeinTile"
      nativeAction="view-trade-offer"
      smallerSize={isMobile}
      analyticsId="Trade-in Tile"
    >
      <StyledTile>
        <CarIcon />
        <TextLines top="trade in your car" bottom="with carvana" />
        <BlueButton>GET YOUR OFFER</BlueButton>
      </StyledTile>
    </ClickableTile>
  );
}
